import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Déconnexion — porte + flèche sortante duotone */
export const LogOutIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Porte menthe */}
      <path
        d="M4 4.5h7v15H4a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.55"
      />
      {/* Contour porte */}
      <path
        d="M4 4.5h7v15H4a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Flèche sortante */}
      <path
        d="M11 12h10M17 8l4 4-4 4"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
LogOutIcon.displayName = "LogOutIcon";
